import { put, takeEvery, all } from 'redux-saga/effects';
import * as constants from '../constants/informationNote';
import * as informationNotePageActions from '../actions/informationNote';
import { SecurityContextType, MessageState } from '../../models/components/announcement.d';
import { Log } from 'ng2-logger';
import { Common } from '../../core/common';
import { InformationNoteService } from '../../api/information-note-services';
import * as coreActions from '../actions/core';
import { Notification } from '../../components/notification/main';

import Translator from '../../core/i18n';
const T = Translator.create();
const _logger = Log.create('Information Note Saga');
const _informationNoteService = new InformationNoteService();

//#region "Add Assignment Activity Saga"
function* setAddInformationNoteActivity(params: any): any {
    let isError = false;
    let errorList: any;
    try {
        const pageData = yield _informationNoteService.RequestAddInformationNoteActivityAsync(params).then((responseData: Response) => {
            return responseData;
        }).then((responseData: Response) => {
            if(responseData.status !== 200) {
                isError = true;             
            }    
            return responseData.json();      
        }).then((response) => {
            if(isError) {
                errorList = response;
            } else {
                return response;
            }
        });

        if (isError) {
            Object.keys(errorList).forEach((key: any) => {
                Notification.setNotification('error', T.t(errorList[key]), 'topRight');
            });
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
            if (params.callback) {
                params.callback(null);
            }
        }
        if (!isError) {
            yield put(
                coreActions.newNotification(
                    params.InformationNoteData.activityId 
                        ? T.t('r_update_activity_succesful_notification') 
                        : T.t('r_add_activity_succesful_notification'),
                    '',
                    '',
                    'topRight',
                    'success'
                )
            );
            const redirectPageParams: any = { 
                submitValues: params.InformationNoteData,
                activityId: params.InformationNoteData.projectActivityId ? params.InformationNoteData.projectActivityId : params.InformationNoteData.activityId ? params.InformationNoteData.activityId : pageData,

                termWeekId:
                    params.InformationNoteData.termWeekIds && params.InformationNoteData.termWeekIds[0] !== '0'
                        ? params.InformationNoteData.termWeekIds[0]
                        : params.InformationNoteData.termWeekIds[1]
            };
            yield put(informationNotePageActions.addInformationNoteSetAction(null));
            params.callback(redirectPageParams);
        }
    } catch (error: any) {
        yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        Notification.setNotification('error', error, 'topRight');
        if (params.callback) {
            params.callback(null);
        }
    }
}

// update information note data!!!
function* setInformationNoteActivity(params: any) : any {
    let isError = false;
    let errorList: any;

    try {
        yield put(informationNotePageActions.addInformationNoteSetAction(null));
        const pageData = yield _informationNoteService
            .RequestGetInformationNoteAsync({ ...params, take: 20, skip: 0 })
            .then((response: Response) => {
                return response;
            })
            .then((response: Response) => {
                if (response.status !== 200) {
                    isError = true;
                }
                return response.json();
            })
            .then((responseData: any) => {
                if (isError) {
                    errorList = responseData;
                } else {
                    return responseData;
                }
            })
            .then((data: any | null) => {
                if (!data) {
                    return null;
                } else {
                    return data;
                }
            });

            if(isError) {
                errorList ? 
                Object.keys(errorList).forEach((key: any) => {
                    Notification.setNotification('error', T.t(errorList[key]), 'topRight');
                }) : Notification.setNotification('error', T.t('r_api_gen_update_activity_error'), 'topRight');
                
                return false;
            } else {
                yield put(informationNotePageActions.addInformationNoteSetAction(pageData, params.spinnerId, 'set'));
                return true;
            }
        
    } catch (error: any) {
        Notification.setNotification('error', T.t('r_api_gen_update_activity_error'), 'topRight');
        return false;
    }
}

function* setDeleteInformationNoteActivity(params: any): any {
    try {
        const pageData = yield _informationNoteService
            .RequestDeleteInformationNoteActivityAsync(params)
            .then((responseData: Response) => {
                return responseData;
            })
            .then((data: any | null) => {
                if (data === undefined || data === false) {
                    return null;
                } else {
                    return data;
                }
            });

        yield put(informationNotePageActions.addInformationNoteSetAction(null));
    } catch (error: any) {
        Notification.setNotification('error', T.t('r_document_activity_pdf_viewing_error_message'), 'topRight');
    }
}

//#endregion "Course Assignment Grade Student List"

export function* watchGetAddInformationNoteData() {
    yield takeEvery(constants.actions.ADD_INFORMATION_NOTE_ACTIVITY, setAddInformationNoteActivity);
    return null;
}

export function* watchGetDeleteInformationNoteData() {
    yield takeEvery(constants.actions.DELETE_INFORMATION_NOTE_ACTIVITY, setDeleteInformationNoteActivity);
    return null;
}

export function* watchUpdateInformationNoteData() {
    yield takeEvery(constants.actions.ADD_INFORMATION_NOTE_UPDATE_ACTIVITY, setInformationNoteActivity);
    return null;
}

//#endregion "Add Assignment Activity End Saga"

export function* InformationNoteSagas() {
    yield all([watchGetAddInformationNoteData(), watchGetDeleteInformationNoteData(), watchUpdateInformationNoteData()]);
}
